import { ContractNegotiation } from '../models/Entities/Contracts/ContractNegotiation';
import { NewContractNegotiation } from '../models/Entities/Contracts/NewContractNegotiation';
import { IResult } from '../models/HttpResult';
import * as Functions from '../functions/common';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'contracts/';

const GetRequestConfig = (token: string, method?: string, body?: unknown): RequestInit => ({
  method,
  body: body !== undefined ? JSON.stringify(body) : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  },
});

const HandleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    throw response;
  }

  const data = (await response.json()) as IResult<T>;
  return data.data;
};

const HandleError = async (error: any) => {
  const body = await error.text();
  throw Functions.HttpErrorHandler(body, error);
};

export const GetContractNegotiations = async (contractId: number, token: string): Promise<ContractNegotiation[]> => {
  const requestUrl = BaseURL + contractId + '/negotiations/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiation[]>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const GetContractNegotiationsByAddendumId = async (contractAddendumId: number, token: string): Promise<ContractNegotiation[]> => {
  const requestUrl = BaseURL + 'addendums/' + contractAddendumId + '/negotiations/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiation[]>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const GetContractNegotiationById = async (id: string, token: string): Promise<ContractNegotiation> => {
  const requestUrl = BaseURL + 'negotiations/' + id;

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiation>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const CreateContractNegotiation = async (contractNegotiation: NewContractNegotiation, token: string): Promise<ContractNegotiation> => {
  const requestUrl = BaseURL + 'negotiations/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'POST', contractNegotiation))
      .then((response) => HandleResponse<ContractNegotiation>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const UpdateContractNegotiation = async (contractNegotiation: ContractNegotiation, token: string): Promise<ContractNegotiation> => {
  const requestUrl = BaseURL + 'negotiations/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'PUT', contractNegotiation))
      .then((response) => HandleResponse<ContractNegotiation>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const DeleteContractNegotiation = async (id: string, token: string): Promise<string> => {
  const requestUrl = BaseURL + 'negotiations/' + id;

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'DELETE'))
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        return id;
      })
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};